import { useTemplateContext } from '../../pages/template-builder/context/TemplateContext';
import TablePagination from './TablePagination';

const TemplateListPagination = () => {
  const {
    currentPage,
    showEntries,
    setshowEntries,
    totalCount,
    totalPages,
    handlePageChange,
    templateListData,
  } = useTemplateContext();

  const startEntry = currentPage === 1 ? 1 : ((currentPage - 1) * showEntries) + 1;
  const endEntry = ((currentPage - 1) * showEntries) + templateListData.length;

  return (
    <TablePagination
      startEntry={startEntry}
      endEntry={endEntry}
      totalCount={totalCount}
      pageSize={showEntries}
      onPageSizeChange={setshowEntries}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={handlePageChange}
      className="mt-3"
    />
  );
};

export default TemplateListPagination;
